import { useEffect, useRef } from 'react';
import { createAudioContext } from '@/features/doctor-queue/chime';

/** STAFF-CHAT — a quiet single note, distinct from the queue's arrival chime. */
export function playMessageSound(ctx: AudioContext | null): void {
  if (!ctx || ctx.state !== 'running') return;
  try {
    const at = ctx.currentTime;
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(660, at);
    gain.gain.setValueAtTime(0.0001, at);
    gain.gain.exponentialRampToValueAtTime(0.035, at + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.22);
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start(at);
    oscillator.stop(at + 0.24);
  } catch {
    // Autoplay blocks and closed contexts must never interrupt work.
  }
}

// Like the queue chime, keep gesture permission across SPA navigation.
let messageContext: AudioContext | null = null;

export function useStaffChatSound(unread: number | undefined) {
  const previous = useRef<number | undefined>(undefined);
  useEffect(() => {
    const arm = () => {
      messageContext ??= createAudioContext();
      void messageContext?.resume().catch(() => {});
    };
    arm();
    window.addEventListener('pointerdown', arm);
    window.addEventListener('keydown', arm);
    return () => {
      window.removeEventListener('pointerdown', arm);
      window.removeEventListener('keydown', arm);
    };
  }, []);
  useEffect(() => {
    if (unread === undefined) return;
    if (previous.current !== undefined && unread > previous.current)
      playMessageSound(messageContext);
    previous.current = unread;
  }, [unread]);
}
